import { Api } from '../AApi'

export const API_LAYERGROUP = new Api(
  {
    url: 'layergroups',
    only: ['list', 'destroy', 'getDetail'],
  },
  {
    create: {
      async request(workspace_id, data) {
        return this.sdk
          .request({
            method: 'post',
            url: `workspaces/${workspace_id}/layergroups`,
            data,
          })
          .then((res) => res.data)
      },
    },
    update: {
      async request(workspace_id, id, data) {
        return this.sdk
          .request({
            method: 'put',
            url: `workspaces/${workspace_id}/layergroups/${id}`,
            data,
          })
          .then((res) => res.data)
      },
    },
  }
)
